<template>
  <div id="app">
    <Header></Header>
    <typeNav></typeNav>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  data() {
    return{

    }
  },
  components: {
    Header
  },
}
</script>
<style scoped>
 /* body,html,#app{
    background-color: #fff !important;
    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
 } */
</style>

